import { render, staticRenderFns } from "./CasesPage.vue?vue&type=template&id=ba6ba574&scoped=true"
import script from "./CasesPage.vue?vue&type=script&lang=js"
export * from "./CasesPage.vue?vue&type=script&lang=js"
import style0 from "./CasesPage.vue?vue&type=style&index=0&id=ba6ba574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6ba574",
  null
  
)

export default component.exports